import { Subscription } from 'rxjs';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { TemplateModel } from 'projects/core/src/lib/models/template.model';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-template-list',
  templateUrl: './template-list.component.html',
  styleUrls: ['./template-list.component.scss']
})
export class TemplateListComponent extends BaseList implements OnInit, OnDestroy {

  public allTemplates: Array<TemplateModel> = [];
  public templates: Array<TemplateModel> = [];
  public subscriptions: Array<Subscription> = [];
  public loading = false;
  public messages: Array<any> = [];
  public apiUrl = '/templates';

  public form = this.fb.group({
    show_inactive: new UntypedFormControl(localStorage.getItem('template-list-show-inactive') === 'true')
  });

  protected rightLoad = 'admin.template.list';
  protected rightNew = 'admin.template.create';
  protected rightOpen = 'admin.template.show';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    private fb: UntypedFormBuilder,
    public transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.templates'));
    this.loadList();
    this.subscriptions.push(this.form.get('show_inactive').valueChanges.subscribe((value: boolean) => {
      localStorage.setItem('template-list-show-inactive', value.toString());
      this.setListData();
    }));
  }

  ngOnDestroy(): void {
    this.helper.unsetSubscriptions(this.subscriptions);
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('templates').subscribe({
      next: (templates: any) => {
        this.allTemplates = [];
        templates.data.forEach((template: any) => {
          this.allTemplates.push(new TemplateModel().deserialize(template));
        });
        this.setListData();
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

  private setListData(): void {
    this.templates = this.allTemplates.filter((template: TemplateModel) => {
      return this.form.get('show_inactive').value === true || template.status === 'template';
    });
  }

}
